import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fd81d08"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-search" }, "Top Searches", -1))
const _hoisted_2 = { class: "ranking-list" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.top_searches, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item,
          onClick: ($event: any) => ($setup.onHotSearchs(item))
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              class: _normalizeClass({ranking_one:(index ) == 0,ranking_tow:(index) == 1,ranking_three:(index ) == 2})
            }, [
              _createElementVNode("i", null, _toDisplayString(index + 1), 1)
            ], 2),
            _createTextVNode(" " + _toDisplayString(item), 1)
          ])
        ], 8, _hoisted_3))
      }), 128))
    ])
  ], 64))
}